import styled from 'styled-components';
import {device} from 'styled/device';

export const Icon = styled.img``;

export const PanelsGroupWrapper = styled.div`
  margin-bottom: 24px;
  width: 280px;

  @media (min-width: ${device.mobileM}) {
    width: 325px;
  }

  @media (min-width: ${device.tablet}) {
    width: 100%;
  }
`;

export const PanelsGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${device.tablet}) {
    display: grid;
    gap: 16px;
    width: 100%;
    grid-template-columns: 1fr;
  }

  @media (min-width: ${device.laptopM}) {
    display: grid;
    gap: 16px;
    width: 856px;
    grid-template-columns: 1fr 1fr;
  }
`;
